"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startDictate;
exports.START_DICTATE = void 0;
var START_DICTATE = 'WEB_CHAT/START_DICTATE';
exports.START_DICTATE = START_DICTATE;

function startDictate() {
  return {
    type: START_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0YXJ0RGljdGF0ZS5qcyJdLCJuYW1lcyI6WyJTVEFSVF9ESUNUQVRFIiwic3RhcnREaWN0YXRlIiwidHlwZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGFBQWEsR0FBRyx3QkFBdEI7OztBQUVlLFNBQVNDLFlBQVQsR0FBd0I7QUFDckMsU0FBTztBQUFFQyxJQUFBQSxJQUFJLEVBQUVGO0FBQVIsR0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RBUlRfRElDVEFURSA9ICdXRUJfQ0hBVC9TVEFSVF9ESUNUQVRFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RhcnREaWN0YXRlKCkge1xuICByZXR1cm4geyB0eXBlOiBTVEFSVF9ESUNUQVRFIH07XG59XG5cbmV4cG9ydCB7IFNUQVJUX0RJQ1RBVEUgfTtcbiJdfQ==